<template lang="pug">
Loading(v-if="userRequestFail")
table.ta(v-else)
	thead.ta-section.ta-section--head
		tr.ta-row
			th.ta-col(
				v-for="stat of statNames"
				v-if="showStat(stat)"
				:key="stat.id"
				@click="sortBy(stat)"
				:class="setTableClass(stat)"
			)
				.ta-col__icon(v-if="showPlayerState(stat)")
					img(:src="getIcon(stat)")
				span(v-else-if="isImage(stat) && isOverview")
				span(v-else) {{ $t(stat) }}

	tbody.ta-section.ta-section--body
		tr.ta-row(
			v-for="player of ordered_list"
		)
			td.ta-col(
				v-for="(value, key) of player"
				:key="key.id"
				v-if="showStat(key)"
				:class="setTableClass(key)"
			)
				img.ta-col__img(
					v-if="isStarterStat(key)"
					:src="player.image ? player.image : '/jugador-desconocido.jpg'"
				)
				img.ta-col__img(
					v-if="isImage(key)"
					:src="player.image ? player.image : '/jugador-desconocido.jpg'"
				)
				.ta-col__icon(v-if="isStarterStat(key)")
					img(
						v-if="player['cinco_inicial']"
						src='/starter.png'
					)
				.ta-col__icon(v-if="isPlayingStat(key)")
					img(v-if="player['jugando']" src='/playing.png')
				span(v-else-if="isPlayedTime(key) && !isUpdate") {{ parsedMinutes(value) }}
				span(v-else-if="isShootingStat(key) && !isUpdate") {{ parsedShootingStat(value) }}
				span(v-else-if="!isPlayingStat(key) && !isStarterStat(key) && !isImage(key) && !isUpdate") {{ value }}
				AnimatedValue(
					v-else-if="isPlayedTime(key) && isUpdate"
					:value="parsedMinutes(value)"
				)
				AnimatedValue(
					v-else-if="isShootingStat(key) && isUpdate"
					:value="parsedShootingStat(value)"
				)
				AnimatedValue(
					v-else-if="!isPlayingStat(key) && !isStarterStat(key) && !isImage(key) && isUpdate"
					:value="value"
				)

	tfoot.ta-section.ta-section--foot
		tr.ta-row.ta-row--tot_team(v-if="!isOverview")
			th.ta-col.ta-col--tt(
				:colspan="(isOverview) ? '3' : (isPlaying ? '4' : '3')"
			) {{ $t('Team')}}
			td.ta-col(
				v-for="(value, key) of (isLocalSelected ? data.local_global : data.visiting_global)"
				:key="key.id"
				v-if="showStat(key) && !isImage(key)"
			)
				AnimatedValue(
					v-if="!isImage(key)"
					:value="value"
				)
		tr.ta-row
			th.ta-col.ta-col--tt(
				:colspan="(isOverview) ? '3' : (isPlaying ? '4' : '3')"
			) {{ $t('Totals')}}
			td.ta-col(
				v-for="(value, key) of filtered_totals"
				:key="key.id"
				v-if="showStat(key) && !isImage(key)"
				:class="setTableClass(key)"
			)
				AnimatedValue(
					v-if="!isImage(key)"
					:value="value"
				)


</template>

<style lang="sass">

</style>

<script>
import api from "@/api/index";

import Loading from "@/components/subcomponents/general/Loading.vue";
import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue";

export default {
	name: "BoxScoreTable",
	props: {
		team: String
	},
	data() {
		return {
			current_sort: null,
			current_sort_dir: -1,
			ordered_list: [],
			totals: null,
			filtered_totals: [],
			data: {
				local_team: [],
				visiting_team: [],
				local_global: {},
				visitor_global: {},
			},
			userRequestFail: false,
			timer: null,
			isUpdate: false,
		}
	},
	computed: {
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		idMatch() {
			return this.$store.state.match.id
		},
		statNames() {
			if (this.$data.data.local_team.length) {
				return Object.keys(this.$data.data.local_team[0]);
			}
			return [];
		},
		isOverview() {
			return (this.$route.name.split('.')[1] == 'overview')
		},
		isLocalSelected() {
			return this.$store.state.match.selTeam == 'local'
		},
		isPlaying() {
			return this.$store.state.match.status == 'playing'
		},
		isFinished() {
			return this.$store.state.match.status == 'finished'
		},
		statusFilterImage() {
			if (this.isPlaying)
				return this.isSortedBy('jugando') ? '/playing.png' : '/playing-black.png'
			else
				return this.isSortedBy('cinco_inicial') ? '/starter.png' : '/starter-black.png'
		},
		period() {
			return this.$store.state.match.selQuarter
		},
		actual() {
			return this.$store.state.general.actual
		}
	},
	methods: {
		getIcon(stat) {
			if (this.isPlayingStat(stat))
				return "/playing.png"
			if (this.isStarterStat(stat))
				return "/starter.png"
		},
		showPlayerState(stat) {
			return (this.isPlayingStat(stat) && !this.isOverview) || (this.isStarterStat(stat) && !this.isOverview)
		},
		setTableClass(stat) {
			let classes = []
			if (this.isPlayingStat(stat))
				classes.push('ta-col--playing')
			if (this.isStarterStat(stat))
				classes.push('ta-col--img')
			if (this.isImage(stat))
				classes.push('ta-col--img')
			if (this.isAsc(stat))
				classes.push('ta-col--selected_asc')
			if (this.isDes(stat))
				classes.push('ta-col--selected_des')
			if (this.isName(stat))
				classes.push('ta-col--name')
			if (this.isNum(stat))
				classes.push('ta-col--num')
			if (this.isSortedBy(stat))
				classes.push('ta-col--selected')
			return classes
		},
		isAsc(stat) {
			return (this.isSortedBy(stat) && (this.$data.current_sort_dir == 1))
		},
		isDes(stat) {
			return (this.isSortedBy(stat) && (this.$data.current_sort_dir == -1))
		},
		isFilter(stat) {
			let filters = [
				'cinco_inicial',
				'dorsal',
				'nombre',
				'puntos',
				'tiempo_jugado',
				'masmenos',
				't3',
				't3p',
				't2',
				't2p',
				't1',
				't1p',
				'rd',
				'ro',
				'rt',
				'asis',
				'br',
				'bp',
				'ct',
				'tf',
				'tc',
				'tr',
				'mates',
				'fp',
				'fr',
				'val'
			]
			if (this.isPlaying)
				filters.push('jugando')
			return (filters.indexOf(stat) >= 0)
		},
		isOvStat(stat) {
			let filters = [
				'image',
				'dorsal',
				'nombre',
				'puntos',
				'rt',
				'asis',
				'val'
			]
			return (filters.indexOf(stat) >= 0)
		},
		showStat(stat) {
			if (this.isOverview) {
				return this.isOvStat(stat)
			} else {
				return this.isFilter(stat)
			}
		},
		isPlayedTime(stat) {
			return (stat == 'tiempo_jugado')
		},
		isNum(stat) {
			return (stat == 'dorsal')
		},
		isName(stat) {
			return (stat == 'nombre')
		},
		isStarterStat(stat) {
			return (stat == 'cinco_inicial')
		},
		isPlayingStat(stat) {
			return (stat == 'jugando')
		},
		isImage(stat) {
			return (stat == 'image')
		},
		isSortedBy(stat) {
			return (stat == this.current_sort)
		},
		parsedMinutes(value) {
			let totalMin = value / 60
			let min = Math.floor(totalMin)
			let sec = Math.floor((totalMin - min) * 60)
			let parsedSec = sec < 10 ? ('0' + sec) : sec
			return (min + ':' + parsedSec)
		},
		getCurrentTeamList() {
			if (this.isOverview) {
				if (this.$props.team == 'local') {
					return (this.data.local_team)
				} else {
					return (this.data.visiting_team)
				}
			} else {
				if (this.isLocalSelected) {
					return (this.data.local_team)
				} else {
					return (this.data.visiting_team)
				}
			}
		},
		filterTotals() {
			if (this.isOverview) {
				if (this.$props.team == 'local')
					this.filtered_totals = this.totals.local_team
				else
					this.filtered_totals = this.totals.visiting_team
			} else {
				if (this.isLocalSelected)
					this.filtered_totals = this.totals.local_team
				else
					this.filtered_totals = this.totals.visiting_team
			}
			this.$data.userRequestFail = false
		},
		sortBy(stat) {
			if (stat == this.current_sort) {
				this.$data.current_sort_dir = (this.$data.current_sort_dir == 1) ? -1 : 1
			}
			this.$data.current_sort = stat
			this.order()
		},
		setPlayerPool() {
			if (this.isOverview) {
				let ov_list = []
				let i = 0
				for (let player of this.getCurrentTeamList()) {
					if (i < 5) {
						if (player['jugando'] && this.isPlaying) {
							ov_list.push(player)
							i++
						} else if (player['cinco_inicial'] && !this.isPlaying) {
							ov_list.push(player)
							i++
						}
					}
				}
				return ov_list
			} else {
				return this.getCurrentTeamList()
			}
		},
		order() {
			let player_pool = []
			player_pool = this.setPlayerPool()
			player_pool.sort((a, b) => {
				if (this.current_sort == 'dorsal') {
					if (+a[this.current_sort] < +b[this.current_sort]) {
						return -1 * this.current_sort_dir
					}
					if (+a[this.current_sort] > +b[this.current_sort]) {
						return 1 * this.current_sort_dir
					}
					if (a[this.current_sort] == b[this.current_sort]) {
						if (+a['dorsal'] > +b['dorsal']) {
							return 1
						} else {
							return -1
						}
					}
				} else {
					if (a[this.current_sort] < b[this.current_sort]) {
						return -1 * this.current_sort_dir
					}
					if (a[this.current_sort] > b[this.current_sort]) {
						return 1 * this.current_sort_dir
					}
					if (a[this.current_sort] == b[this.current_sort]) {
						if (+a['dorsal'] > +b['dorsal']) {
							return 1
						} else {
							return -1
						}
					}
				}
				return 0
			})
			this.$store.commit("general/setBoxscoreReady", true)
			if (this.$props.team == 'local') {
				this.$store.commit("general/setOvLocalReady", true)
			} else {
				this.$store.commit("general/setOvVisitorReady", true)
			}
			this.ordered_list = player_pool
			this.isUpdate = false
		},
		isShootingStat(stat) {
			if (stat == "t1p" || stat == "t2p" || stat == "t3p") {
				return true;
			}
			return false;
		},
		parsedShootingStat(value) {
			let roundedValue = Math.round(value);
			return roundedValue.toString() + "%";
		},
		setTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.userRequestFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearTimer() {
			if (this.timer) {
				this.$data.userRequestFail = false
				clearTimeout(this.timer)
			}
		},
		updateStatsPlayerList() {
			let period = (this.isOverview || this.$store.state.match.status == 'roaster-ready') ? null : this.period
			let params = {
				idMatch: this.$route.params.id_match,
			}
			if (period) {
				params['period'] = period
			}
			api.match.getPlayersStats(params)
				.then((data) => {
					this.$data.data.local_team = data.local_team
					this.$data.data.visiting_team = data.visiting_team
					this.$data.data.local_global = data.local_global
					this.$data.data.visiting_global = data.visiting_global
					this.order()
					this.clearTimer()
				}
				)
		},
		updateMatchTotalStats() {
			api.match.getMatchTotalStats(this.$route.params.id_match, this.period)
				.then((data) => {
					this.$data.totals = data
					this.filterTotals()
				}
				)
		},
		newMatch() {
			this.setTimer()
			this.$store.commit("general/setBoxscoreReady", false)
			this.updateMatchTotalStats()
			this.updateStatsPlayerList()
			if (this.isPlaying && !this.$data.current_sort)
				this.current_sort = 'jugando'
			else
				this.current_sort = 'cinco_inicial'
		}
	},
	watch: {
		isLocalSelected() {
			this.order()
			this.filterTotals()
		},
		period() {
			this.setTimer()
			this.updateMatchTotalStats()
			this.updateStatsPlayerList()
		},
		actual: {
			handler: function () {
				if (this.data.local_team.length) {
					this.updateMatchTotalStats()
					this.updateStatsPlayerList()
					this.isPlaying ? this.current_sort = 'jugando' : this.current_sort = 'cinco_inicial'
				}
			},
			deep: true
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing) {
					this.$store.isUpdate = true
					this.updateMatchTotalStats()
					this.updateStatsPlayerList()
				}
			}
		}
	},
	created() {
		this.newMatch()
	},
	mounted() {
	},
	components: {
		Loading,
		AnimatedValue
	}
}

</script>
